<template>
  <div class="help-tabs">
    <div class="help-tabs-header">
      <p class="help-tabs-header-left"
        :class="{ 'help-tabs-header-active': activeTab === 0}"
        @click="setActiveTab(0)">
        For Businesses
      </p>
      <p :class="{ 'help-tabs-header-active': activeTab === 1}"
        @click="setActiveTab(1)">
        For Students
      </p>
      <p class="help-tabs-header-right"
        :class="{ 'help-tabs-header-active': activeTab === 2}"
        @click="setActiveTab(2)">
        For Universities
      </p>
    </div>

    <div class="help-tabs-benefits" v-if="activeTab === 0">
      <div class="benefit">
        <icon name="network-oval" />
        <p>Connect you with business consultants</p>
      </div>
      <div class="benefit">
        <icon name="rocket-oval" />
        <p>Help with business & marketing plan development</p>
      </div>
      <div class="benefit">
        <icon name="press-oval" />
        <p>Prepare materials for business presentations</p>
      </div>
      <div class="benefit">
        <icon name="find-oval" />
        <p>Find interns and new candidates to join your team</p>
      </div>
    </div>
    <div class="help-tabs-benefits" v-if="activeTab === 1">
      <div class="benefit">
        <icon name="pass-oval" />
        <p>Assist in getting into the school of your dreams</p>
      </div>
      <div class="benefit">
        <icon name="sources-oval" />
        <p>Find & send you all needed sources, books and materials</p>
      </div>
      <div class="benefit">
        <icon name="hands-oval" />
        <p>Get you in touch with the experienced tutor</p>
      </div>
      <div class="benefit">
        <icon name="messages-oval" />
        <p>Inform about relevant job and internship opportunities</p>
      </div>
    </div>
    <div class="help-tabs-benefits" v-if="activeTab === 2">
      <div class="benefit">
        <icon name="intership-oval" />
        <p>Find internships<br> for students</p>
      </div>
      <div class="benefit">
        <icon name="tests-oval" />
        <p>Create study tests for<br> numerous courses</p>
      </div>
      <div class="benefit">
        <icon name="partnerships-oval" />
        <p>Facilitate corporate<br> partnerships</p>
      </div>
      <div class="benefit">
        <icon name="scouting-oval" />
        <p>Help with talent scouting</p>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon'
export default {
  components: {
    Icon
  },
  data: () => ({
    activeTab: 1
  }),
  methods: {
    setActiveTab (id) {
      this.activeTab = id
    }
  }
}
</script>

<style lang="scss">
  @import '~@/styles/media';

  .help-tabs {
    max-width: 900px;
    margin: 0 auto;

    &-header {
      text-align: center;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      font-size: 12px;

      p {
        border-top: 3px solid var(--primary-green);
        border-bottom: 3px solid var(--primary-green);
        padding: 15px 7px;
        cursor: pointer;
        transition: all .2s ease-in-out;
        font-family: 'ProximaNova-Bold';
        font-size: 18px;

        @media #{$mobile} {
          border-width: 1px;
        }

        @media #{$lxs} {
          font-size: 3vw;
          padding: 12px 7px;
        }

        &:hover {
          background-color: var(--primary-green-hover);
          color: var(--primary-white);
        }
      }

      &-left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        border-left: 3px solid var(--primary-green);
        border-right: 3px solid var(--primary-green);
      }

      &-active {
        background-color: var(--primary-green);
        color: var(--primary-white);

        &:hover {
          background-color: var(--primary-green)!important;
        }
      }

      &-right {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        border-left: 3px solid var(--primary-green);
        border-right: 3px solid var(--primary-green);
      }
    }

    &-benefits {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 20px;
      grid-row-gap: 20px;
      font-size: 14px;
      margin-top: 20px;
      text-align: center;

      .img {
        width: 68px;
        height: 68px;
        margin: 0 auto;
        background-color: var(--img-grey);
        border-radius: 100%;
      }
    }

    @media #{$desktop} {
      &-header {
        font-size: 18px;
        grid-template-columns: 1fr 1fr 1fr;
      }

      &-benefits {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-column-gap: 20px;
        font-size: 18px;
        line-height: 26px;
        margin-top: 20px;
        height: 175px;
        text-align: center;
        font-family: 'ProximaNova-Regular';

        .img {
          width: 68px;
          height: 68px;
          margin: 0 auto;
          background-color: var(--img-grey);
          border-radius: 100%;
        }
      }
    }

    @media #{$xs} {
      &-header {
        font-size: 10px;
      }
    }
  }
</style>
